export const siteConfig = {
  name: 'つくってなんぼ',
  title: 'つくってなんぼ | AIで作る・整える・速くする 実践メディア',
  description: 'AIを使って何かを作る・整える・速くする。個人開発、業務効率化、ツール活用を制作プロジェクト起点で届ける日本語の実践メディア。読んで終わりじゃない、手を動かすための記事を発信。',
  keywords: 'AI活用,個人開発,業務効率化,AI制作,Cursor,Claude,プロンプト,制作記録,ツール活用,実践メディア',
  url: 'https://tsukutte-nanbo.com',
  ogImage: '/og-image.png',
  locale: 'ja_JP',
  tagline: '作って、直して、速くする。',
  subtagline: '読んで終わりじゃない実践メディア',
} as const;
